import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import deepEqual from 'deep-equal'
import classNames from 'classnames'
import {
  getBoundingBox,
  uniqueElements,
  subPath,
  getObject,
} from '@adalo/utils'

import { getInboundLinks } from 'ducks/apps'
import { selectObjects, getMap } from 'ducks/editor/objects'
import { getPathData, getArrowPath } from 'utils/arrows'

import './Links.scss'

export function Link(props) {
  const { source, target, zoom, selected } = props

  if (!source || !target) {
    return null
  }

  const path = getPathData(source, target, zoom)
  const arrow = getArrowPath(source, target, zoom)

  return (
    <g
      className={classNames(
        'link-wrapper',
        selected && 'link-wrapper-selected'
      )}
    >
      <path className="link-hover-path" d={path} />
      <path className="link-path" d={path} />
      <path className="link-arrow" d={arrow} />
    </g>
  )
}

class Links extends Component {
  shouldComponentUpdate(prevProps) {
    const { inboundLinks, screens, zoom, selection } = this.props

    if (zoom !== prevProps.zoom || selection !== prevProps.selection) {
      return true
    }

    for (const key of Object.keys({ ...screens, ...prevProps.screens })) {
      const prevScreen = prevProps.screens[key]
      const screen = screens[key]

      if (!prevScreen || !screen) {
        return true
      }

      if (
        prevScreen.x !== screen.x ||
        prevScreen.y !== screen.y ||
        prevScreen.width !== screen.width ||
        prevScreen.height !== screen.height
      ) {
        return true
      }
    }

    return !deepEqual(prevProps.inboundLinks, inboundLinks)
  }

  getScreen = screenId => {
    const { screens, screensMap } = this.props
    const screen = screens[screensMap[screenId]]

    if (!screen) {
      return null
    }

    return getBoundingBox([screen])
  }

  getSelectedScreens = () => {
    const { screens, screensMap, selection } = this.props

    let screenPaths = selection.map(id => subPath(screensMap[id], 1))
    screenPaths = uniqueElements(screenPaths)

    const screenIds = screenPaths.map(path => getObject(screens, path)?.id)

    return screenIds
  }

  render = () => {
    const { inboundLinks, zoom } = this.props
    const selection = this.getSelectedScreens()

    return (
      <g
        className={classNames(
          'canvas-link-map',
          selection.length > 0 && 'canvas-link-map-selected'
        )}
      >
        {Object.keys(inboundLinks).map(target => (
          <React.Fragment key={target}>
            {inboundLinks[target].map(source => (
              <Link
                key={source}
                source={this.getScreen(source)}
                target={this.getScreen(target)}
                zoom={zoom}
                selected={
                  selection.includes(source) || selection.includes(target)
                }
              />
            ))}
          </React.Fragment>
        ))}
      </g>
    )
  }
}

const mapStateToProps = (state, { match }) => {
  const { appId } = match.params

  return {
    inboundLinks: getInboundLinks(state, appId),
    screens: selectObjects(state),
    screensMap: getMap(state),
  }
}

export default withRouter(connect(mapStateToProps)(Links))
